

<footer class="app-footer">
  <div class="footer-container">
    <div class="footer-brand">
      <h2>Busy Guys</h2>
      <p>Effortless scheduling for individuals and teams.</p>
    </div>

    <div class="footer-links">
        <a [routerLink]="['/features']">{{ 'features.link_label' | translate }}</a>
        <a [routerLink]="['/terms-and-conditions']">Terms & Conditions</a>
        <a [routerLink]="['/data-protection']">Data Protection</a>
      <a [routerLink]="['/contact']">{{ 'contact.link_label' | translate }}</a>
      <a [routerLink]="['sign-in']">Login</a>
      </div>

      <div class="footer-social">
      <a class="social-icon" href="#"><app-facebook-icon/></a>
      <!-- <a class="social-icon" href="#"><img src="assets/vectors/twitter-colorless.svg" alt="Twitter" /></a> -->
      <a class="social-icon" href="#"><app-instagram-icon/></a>
      </div>
    </div>

  <div class="footer-bottom">
    <p>&copy; {{Year}} Busy Guys. All rights reserved.</p>
  </div>
</footer>

